module.exports = __webpack_public_path__ + "static/img/Ronaldo-Mulitalo.0e43536.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ronaldo-Mulitalo.jpg
// module id = mbpM
// module chunks = 0